// extracted by mini-css-extract-plugin
export default {"loading":"placeholderMap_loading__5KFPD"};